<template>
  <ODialog ref="dialog" :max-width="600">
    <v-card>
      <ODialogBar title="Preview" @close="dismiss()" />

      <div class="maxh-4">
        <v-expansion-panels accordion multiple focusable hover tile>
          <v-expansion-panel v-for="(segment, index) in segments" :key="index">
            <v-expansion-panel-header>
              Segmento <code>{{ segment.offset | hex('0x') }}</code>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="noPaddingExpansionPanel">
              <pre class="mono pa-3" style="white-space: pre">{{
                segment.bytes | prettyHex
              }}</pre>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>

      <v-card-text class="pa-3" style="border-top: 1px solid #ccc">
        <v-btn large @click="copyAll">
          <v-icon class="mr-2">mdi-clipboard-outline</v-icon>
          Copiar Mailboxes
        </v-btn>
      </v-card-text>

      <!-- <v-card-text
        class="pa-3 children-pa-3"
        v-for="(segment, index) in segments"
        :key="index"
      >
        <div>
          Offset: <code>{{ segment.offset | hex('0x') }}</code>
          <v-btn x-small @click="copyToClipboard(segment)">Copiar</v-btn>
        </div>
        <pre class="mono" style="white-space: pre">{{
          segment.bytes | prettyHex
        }}</pre>
      </v-card-text> -->
    </v-card>
  </ODialog>
</template>

<script>
import { ScreenSet } from '@/models'
import brush from 'brush'
import { jp } from 'oderon-commons/src/utils.js'

function prettyHex(x) {
  return brush.toHex(x, {
    prettyPrint: true,
    bytesPerLine: 16,
    groupSep: '    '
  })
}

export default {
  data() {
    return this.reset()
  },
  methods: {
    reset() {
      return {
        segments: [],
        type: null,
        obj: null
      }
    },

    dismiss() {
      return this.$refs.dialog.$dismiss()
    },

    async open(type, obj) {
      Object.assign(this, this.reset(), { type, obj })
      this.$refs.dialog.$loading(() => this.fetchData())
      return this.$refs.dialog.$open()
    },

    async fetchData() {
      if (this.type == 'screen') {
        let res = await ScreenSet.previewScreen(this.obj)
        this.segments = [{ offset: 0, bytes: res }]
      } else if (this.type == 'screen-set') {
        this.segments = await ScreenSet.previewScreenSet(this.obj)
      }
    },

    copyToClipboard(segment) {
      let obj = {
        address: segment.offset,
        bytes: brush.toHex(segment.bytes)
      }
      navigator.clipboard.writeText(JSON.stringify(obj, null, ' '))
      this.$snack('Copied to clipboard')
    },

    copyAll() {
      let mbScreens = {
        label: 'Telas: ' + this.obj.name,
        information: 'raw',
        contents: {
          screenSetId: this.obj.id,
          address: this.segments[0].offset,
          bytes: brush.toHex(this.segments[0].bytes)
        }
      }

      let mbStrings = {
        label: 'Texto: ' + this.obj.name,
        information: 'raw',
        contents: {
          screenSetId: this.obj.id,
          address: this.segments[1].offset,
          bytes: brush.toHex(this.segments[1].bytes)
        }
      }

      let result = jp([mbScreens, mbStrings])
      navigator.clipboard.writeText(result)

      this.$snack('Mailboxes copiados com sucesso')
    }
  },
  filters: {
    prettyHex
  }
}
</script>
